// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"64":"ca909ef5","805":"87468916"}[chunkId] + ".css";
};